import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const greenRoomApi = dmApi.injectEndpoints({
    endpoints: (build) => ({

        getGreenRoomSortingRecord: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/green-room/sorting-record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['greenRoomSorting'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        getGreenRoomSummary: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/green-room/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['greenRoomSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createGreenRoomSortingData: build.mutation({
            query: (requestBody) => ({
                url: `/rework/green-room/sorting-create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['greenRoomSorting', 'greenRoomSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data");
            },
        }),

        updateGreenRoomSortingData: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/green-room/sorting-update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['greenRoomSorting', 'greenRoomSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data");
            },
        }),

        createGreenRoomOvenData: build.mutation({
            query: (requestBody) => ({
                url: `/rework/green-room/ovens-data/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['greenRoomOvenData', 'greenRoomSummary', 'ovenList', 'cartList'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data");
            },
        }),

        updateGreenRoomOvenData: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/green-room/ovens-data/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['greenRoomOvenData', 'greenRoomSummary', 'ovenList', 'cartList'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data");
            },
        }),

        searchGreenRoomOvenData: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/green-room/ovens-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['greenRoomOvenData'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        searchGreenRoomLogs: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/green-room/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['greenRoomLogs'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        updateGreenRoomLog: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/green-room/logs/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['greenRoomLogs', 'greenRoomSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data");
            },
        }),

    }),
});

export const {
    useGetGreenRoomSortingRecordQuery,
    useGetGreenRoomSummaryQuery,
    useCreateGreenRoomSortingDataMutation,
    useUpdateGreenRoomSortingDataMutation,
    useCreateGreenRoomOvenDataMutation,
    useUpdateGreenRoomOvenDataMutation,
    useSearchGreenRoomOvenDataQuery,
    useSearchGreenRoomLogsQuery,
    useUpdateGreenRoomLogMutation,
} = greenRoomApi;
